import { render } from "./SlidingButton.vue?vue&type=template&id=1fd18b12&scoped=true"
import script from "./SlidingButton.vue?vue&type=script&lang=js"
export * from "./SlidingButton.vue?vue&type=script&lang=js"

import "./SlidingButton.vue?vue&type=style&index=0&id=1fd18b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd18b12"]])

export default __exports__